import styled from "styled-components";
import { colors } from "../../../../theme/theme";

interface IReportCard {
	background: string;
}

export const ReportsWrapper = styled.div`
	padding: 0 12px;

	h2 {
		color: ${colors.greyscale.darker_grey};
		font-size: 20px;
		margin-bottom: 36px;
	}
`;

export const ReportCardWrapper = styled.div`
	display: flex;
	gap: 24px;
`;

export const ReportCard = styled.div<IReportCard>`
	display: flex;
	flex-direction: column;
	max-width: 220px;

	button {
		background: ${(props) =>
			props.background
				? props.background
				: colors.mainColors.dark_orange} !important;
		border-color: transparent !important;

		padding: 32px 16px;
		border-radius: 8px;

		display: flex;
		align-items: center;
		justify-content: center;
		gap: 4px;
	}

	> span {
		margin-top: 8px;
		font-size: 14px;
		color: ${colors.greyscale.darker_grey};
	}
`;

export const ModalReportsControls = styled.div`
	display: flex;
	gap: 24px;

	line-height: 1;
	margin-bottom: 16px;

	> div {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	input,
	label {
		margin: 0;
	}

	input {
		font-size: 18px;
		color: green;
	}

	input:checked {
		background: ${colors.mainColors.verde_dstore};
		border-color: ${colors.mainColors.dark_verde_dstore};
	}
`;
